import getSliceName from '@om-fe/core/utils/get-slice-name';
import {
    TopBetsMatchListGroupsOverviewTopic,
    slicePrefix,
    TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_HOURS_PATH,
    TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH,
    TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_MATCH_LIST_CATEGORY_BY_HOURS_PATH,
    TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH,
    TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_MATCH_LIST_LOCATION_BY_HOURS_PATH,
    TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH,
    TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_HOURS_PATH,
    TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH,
    TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_MATCH_LIST_BY_HOURS_PATH,
    TOP_BETS_MATCH_LIST_BY_DATES_PATH,
    TOP_BETS_MATCH_LIST_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_MATCH_LIST_ALL_BY_HOURS_PATH,
    TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH,
    TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_HOURS_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_HOURS_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_HOURS_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN,
    TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_HOURS_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH,
    TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN,
} from './top-bets-list.constants';
import * as shallowEqual from 'shallowequal';
import { TopBetsMatchListPublicProps } from './top-bets-list';
import { DEFAULT_DISPLAYED_NUMBER_OF_MATCHES } from '@om-fe/core/components/match-list/utils/match-list.constants';
import { TimeRangeType } from '../../utils/top-bets.constants';
import { DisciplineLiveStatus, DisciplinesType } from '@om-fe/models';
import { CUSTOM_MATCH_BY_POPULAR } from '../../../match-list/containers/custom-match-list/custom-match-list.constants';

export function getTopBetsMatchListSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

const STATIC_GROUPS_OVERVIEW: string = '1';

export function getTopBetsMatchListGroupsOverviewTopic(
    disciplineId: string,
    timeRange: string,
    limit: number,
    marketGroupsOverviewIds: string,
    locationId?: string,
    categoryId?: string,
    isTopBets?: boolean,
    isCategory?: boolean,
    timeRangeType?: TimeRangeType,
    timeRangeValue?: string,
    isAuthenForTopic?: boolean,
): TopBetsMatchListGroupsOverviewTopic {
    if (locationId && locationId !== '0' || categoryId) {
        if (isCategory) {
            let topic: string;

            if (isTopBets) {
                if (disciplineId === DisciplinesType.ElectronicSports) {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ?  TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                } else {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_MATCH_LIST_CATEGORY_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_CATEGORY_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                }
            } else {
                if (disciplineId === DisciplinesType.ElectronicSports) {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ? TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                } else {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_CATEGORY_ALL_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                }
            }

            topic = `${topic}/:limit/:groupOverviewId`;

            return {
                path: topic,
                params: {
                    disciplineId: disciplineId === DisciplinesType.ElectronicSports ? undefined : disciplineId,
                    categoryId,
                    timeRange,
                    limit,
                    groupOverviewId: marketGroupsOverviewIds ? marketGroupsOverviewIds : STATIC_GROUPS_OVERVIEW,
                },
            };
        } else {
            let topic: string;
            if (isTopBets) {
                if (disciplineId === DisciplinesType.ElectronicSports) {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ? TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                } else {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_MATCH_LIST_LOCATION_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH_LOGGED_IN: TOP_BETS_MATCH_LIST_LOCATION_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                }
            } else {
                if (disciplineId === DisciplinesType.ElectronicSports) {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ? TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_ESPORTS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                } else {
                    if (timeRangeType === TimeRangeType.HOURS) {
                        topic = TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_HOURS_PATH;
                    } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH
                        topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
                    } else {
                        topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_LOCATION_ALL_BY_DATES_PATH;
                        topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
                    }
                }
            }

            topic = `${topic}/:limit/:groupOverviewId`;

            return {
                path: topic,
                params: {
                    disciplineId: disciplineId === DisciplinesType.ElectronicSports ? undefined : disciplineId,
                    locationId,
                    timeRange,
                    limit,
                    groupOverviewId: marketGroupsOverviewIds ? marketGroupsOverviewIds : STATIC_GROUPS_OVERVIEW,
                },
            };
        }
    } else {
        let topic: string;
        if (isTopBets) {
            if (timeRangeType === TimeRangeType.HOURS) {
                topic = TOP_BETS_MATCH_LIST_BY_HOURS_PATH
            } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_BY_DATES_PATH
                topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
            } else {
                topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_BY_DATES_PATH
                topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
            }
        } else if (!isTopBets && locationId === '0') {
            topic = CUSTOM_MATCH_BY_POPULAR;
        } else {
            if (timeRangeType === TimeRangeType.HOURS) {
                topic = TOP_BETS_MATCH_LIST_ALL_BY_HOURS_PATH;
            } else if (timeRangeType === TimeRangeType.DAYS && timeRangeValue === '0') {
                topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH;
                topic = `${topic}/${DisciplineLiveStatus.BOTH}`;
            } else {
                topic = isAuthenForTopic ? TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH_LOGGED_IN : TOP_BETS_MATCH_LIST_ALL_BY_DATES_PATH;
                topic = `${topic}/${DisciplineLiveStatus.NOT_LIVE}`;
            }
        }

        topic = `${topic}/:limit/:groupOverviewId`;

        return {
            path: topic,
            params: {
                disciplineId,
                timeRange,
                limit,
                groupOverviewId: marketGroupsOverviewIds ? marketGroupsOverviewIds : STATIC_GROUPS_OVERVIEW,
            },
        };
    }
}

interface TopBetsMatchListTopicProps {
    readonly disciplineId: string;
    readonly limitNumberOfEvents: number;
    readonly isTopBets?: boolean; 
    readonly mainMarketsLimit: number | undefined;
}

const getTopicProps = (props: TopBetsMatchListPublicProps): TopBetsMatchListTopicProps => ({
    disciplineId: props.disciplineId,
    limitNumberOfEvents: props.limitNumberOfEvents || DEFAULT_DISPLAYED_NUMBER_OF_MATCHES,
    mainMarketsLimit: props.mainMarketsLimit,
    isTopBets: props.isTopBets,
});

export function areTopBetsMatchListTopicPropsEqual(
    prevProps: TopBetsMatchListPublicProps,
    newProps: TopBetsMatchListPublicProps,
): boolean {
    return shallowEqual(getTopicProps(prevProps), getTopicProps(newProps));
}
